import { FormProvider, useForm } from "react-hook-form";
import styled from "styled-components";
import { ReactComponent as SampleIcon } from "assets/icons/new/search.svg";
import { TextArea } from "common/components/Input/TextArea";
import { SelectButton } from "common/components/Button/new/SelectButton";
import { CheckboxGroup } from "common/components/Button/new/CheckBoxGroup";
import { RadioButtonGroup } from "common/components/Button/new/RadioButtonGroup";
import { Toggle } from "common/components/Button/new/Toggle";
import { ToggleText } from "common/components/Button/new/ToggleText";
import {
  DefaultButton,
  SelectableButton,
} from "common/components/Button/new/DefaultButton";
import { IconWrapper } from "common/components/icon";
import { DefaultTextModal } from "common/components/Modal/DefaultTextModal";
import { useModal } from "common/components/Wrapper/ModalProvider";
import { TagButton } from "common/components/Button/new/TagButton";
import { CheckboxItem } from "common/components/Button/new/CheckBoxItem";
import { RadioItem } from "common/components/Button/new/RadioButtonItem";
import {
  MultiSelectButtonGroup,
  SingleSelectButtonGroup,
} from "common/components/Button/new/FormInputs";
import { colors } from "common/const/colors";
import {
  AddButton,
  DeleteButton,
  RemoveButton,
} from "common/components/Button/new/IconButton";
import {
  ListInnerWrapper,
  ListWrapper,
} from "common/components/Wrapper/ListView";
import { useState } from "react";
import { Calendar, RowEndLayout, TextTitle1 } from "common/components";
import { DefaultLayout } from "common/components/Layout/new/constLayout";
import { TextInput } from "common/components/Input/TextInput";
import { ImagePreview } from "common/components/Button/new/ImagePreview";
import { CloseIcon } from "common/components/Button/new/CloseButton";
import { ComboBoxWithoutValid } from "common/components/Field/new/ComboBoxWithoutValid";
import { ComboBox } from "common/components/Field/new/ComboBox";
import { TimeInput } from "common/components/Input/TimeInput";

const InputGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  min-height: 100px;
  align-items: flex-start;

  & > div:nth-child(4n + 3) {
    height: 100%;
    justify-content: flex-end;
  }

  & > div:nth-child(4n) {
    height: 100%;
    justify-content: center;
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 1rem;
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DesignPage = () => {
  const [selectedValue, setSelectedValue] = useState(null);
  const { openModal, closeModal } = useModal();
  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      input1: "ddddd",
      select: "option3",
      radio1: "opt1",
      toggle3: true,
    },
  });
  const onSubmit = (data) => {
    console.log("Form Values:", data);
  };

  const onError = (errors) => {
    console.error("Validation Errors:", errors);
  };

  const [images, setImages] = useState([
    { id: 1, src: "https://placehold.co/1000" },
    { id: 2, src: "https://placehold.co/1000" },
    { id: 3, src: "https://placehold.co/1000" },
    { id: 4, src: "https://placehold.co/1000" },
    { id: 5, src: "https://placehold.co/1000" },
    { id: 6, src: "https://placehold.co/1000" },
  ]);

  return (
    <DefaultLayout>
      <FormProvider {...methods}>
        <Row>
          <Column style={{ flex: 2 }}>
            <InputGrid>
              <TextTitle1>label=on, inline=on</TextTitle1>
              <TextTitle1>label=on, inline=off</TextTitle1>
              <TextTitle1>label=off, inline=on</TextTitle1>
              <TextTitle1>label=off, inline=off</TextTitle1>

              <TextInput
                name="input1-1"
                placeholder="숫자만 입력"
                label="Title"
                caption="helper message"
                rules={{ required: "입력 필요" }}
                pattern={/^\d*$/}
              />
              <TextInput
                name="input1-2"
                placeholder="Placeholder"
                label="Title"
                rules={{ required: "입력 필요" }}
              />
              <TextInput
                name="input1-3"
                placeholder="Placeholder"
                caption="helper message"
                rules={{ required: "입력 필요" }}
              />
              <TextInput
                name="input1-4"
                placeholder="Placeholder"
                rules={{ required: "입력 필요" }}
              />

              <TextInput
                name="input2"
                placeholder="Placeholder"
                label="Title"
                caption="helper message"
                disabled
              />
              <TextInput
                name="input2"
                placeholder="Placeholder"
                label="Title"
                disabled
              />
              <TextInput
                name="input2"
                placeholder="Placeholder"
                caption="helper message"
                disabled
              />
              <TextInput name="input2" placeholder="Placeholder" disabled />

              <TextInput
                name="input3"
                placeholder="Placeholder"
                label="Title"
                caption="helper message"
                readOnly
              />
              <TextInput
                name="input3"
                placeholder="Placeholder"
                label="Title"
                readOnly
              />
              <TextInput
                name="input3"
                placeholder="Placeholder"
                caption="helper message"
                readOnly
              />
              <TextInput name="input3" placeholder="Placeholder" readOnly />
            </InputGrid>
          </Column>
          <Column>
            <TextTitle1>Input with Icon</TextTitle1>
            <Row>
              <TextInput
                name="iconInput"
                placeholder="input with left icon"
                icon={{
                  element: <SampleIcon fill={colors.Black} />,
                  position: "left",
                }}
              />
              <TextInput
                name="iconInput"
                placeholder="input with right icon"
                icon={{ element: <SampleIcon />, position: "right" }}
              />
            </Row>
            <TextTitle1>TextArea</TextTitle1>
            <TextArea
              name="textarea"
              placeholder="memo, lorem ipsum"
              minHeight={100}
              maxHeight={215}
              rules={{ maxLength: { value: 20 } }}
              showCount
            />
          </Column>
        </Row>
        <Row>
          <Column style={{ flex: 6 }}>
            <SelectButton
              name="select"
              label="Title"
              options={[
                { text: "Option 1", value: "option1" },
                { text: "Option 2", value: "option2" },
                { text: "Option 3", value: "option3" },
              ]}
            />
          </Column>
          <Column>
            <CheckboxGroup
              name="checkgroup2"
              size="medium"
              label="옵션 선택"
              value={["opt3"]}>
              <CheckboxItem value="opt1" label="옵션 1" />
              <CheckboxItem value="opt2" label="옵션 2" />
              <CheckboxItem value="opt3" label="옵션 3" disabled />
              <CheckboxItem value="opt4" label="옵션 4" fixed />
            </CheckboxGroup>
          </Column>
          <Column>
            <CheckboxGroup.ByOptions
              required
              name="checkgroup3"
              size="large"
              label="옵션 선택"
              options={[
                { value: "opt1", label: "옵션 1" },
                { value: "opt2", label: "옵션 2" },
                { value: "opt3", label: "옵션 3" },
                { value: "opt4", label: "옵션 4" },
              ]}
            />
          </Column>
        </Row>
        <Row>
          <CheckboxGroup.ByOptions
            name="checkgroup4"
            size="large"
            label="옵션 선택"
            direction="row"
            options={[
              { value: "opt1", label: "옵션 1" },
              { value: "opt2", label: "옵션 2" },
              { value: "opt3", label: "옵션 3" },
              { value: "opt4", label: "옵션 4", fixed: true },
            ]}
          />
          <RadioButtonGroup.ByOptions
            name="radio1"
            label="Title"
            required
            options={[
              { value: "opt1", label: "옵션 1" },
              { value: "opt2", label: "옵션 2" },
            ]}
          />
          <RadioButtonGroup name="radio2" label="Title" direction="row">
            <RadioItem value="opt3" label="옵션 1" />
            <RadioItem value="opt4" label="옵션 2" />
          </RadioButtonGroup>
          <Column>
            <Toggle size="large" name="toggle1" label="Title" />
            <Toggle size="medium" name="toggle2" label="Title" />
            <Toggle size="small" name="toggle3" label="Title" fixed />
          </Column>
          <Column>
            <ToggleText
              size="large"
              name="toggleText1"
              label="Title"
              options={[
                { label: "Option 1", value: "opt1" },
                { label: "Option 2", value: "opt2" },
              ]}
            />
            <ToggleText
              name="toggleText2"
              options={[
                { label: "Option 1", value: "opt1" },
                { label: "Option 2", value: "opt2" },
              ]}
              disabled
            />
          </Column>
        </Row>
        <Row>
          <DefaultButton
            fillColor="var(--MainBlue)"
            textColor="var(--White)"
            onClick={() => {
              openModal({
                content: (
                  <DefaultTextModal
                    title="Test Modal"
                    bodyText="Test Modal body"
                    rightButtonText={"button1"}
                    rightButtonOnClick={closeModal}
                    leftButtonText={"button2"}
                    leftButtonOnClick={() => console.log("dfsdfsdf")}
                  />
                ),
              });
            }}>
            Test Button
            <IconWrapper>
              <SampleIcon fill="white" stroke="white" />
            </IconWrapper>
          </DefaultButton>
          <MultiSelectButtonGroup name="selectMulti" label="태그 선택">
            <TagButton value="tag1" text="Tag 1" />
            <TagButton value="tag2" text="Tag 2" />
            <TagButton value="tag3" text="Tag 3" />
          </MultiSelectButtonGroup>

          <SingleSelectButtonGroup
            name="selectSingle"
            maxItemWidth="4.5rem"
            maxItemHeight="2.5rem">
            <SelectableButton.ByText value="opt1" text="Thu" />
            <SelectableButton.ByText value="opt2" text="Fri" />
            <TagButton value="tag3" text="Tag 3" />
          </SingleSelectButtonGroup>

          <MultiSelectButtonGroup
            name="selectMulti2"
            maxItemWidth="4.5rem"
            maxItemHeight="2.5rem">
            <SelectableButton.ByText value="mon" text="Mon" disabled />
            <SelectableButton.ByText value="tue" text="Tue" secondary />
            <SelectableButton.ByText value="wed" text="Wed" />
            <SelectableButton.ByText value="thu" text="Thu" />
            <SelectableButton.ByText value="fri" text="Fri" />
            <SelectableButton.ByText value="sat" text="Sat" />
            <SelectableButton.ByText value="sun" text="Sun" />
            <SelectableButton.ByText value="hol" text="Holiday" />
          </MultiSelectButtonGroup>
        </Row>
        <Row>
          <ComboBoxWithoutValid
            label="ComboBox 테스트"
            placeholder="선택하세요"
            value={selectedValue}
            onChange={(item) => setSelectedValue(item.value)}
            itemList={[
              { key: "opt1", value: "opt1", text: "옵션 1" },
              { key: "opt2", value: "opt2", text: "옵션 2" },
              { key: "opt3", value: "opt3", text: "옵션 3" },
            ]}
          />
          <ComboBox
            name="combobox"
            label="ComboBox 테스트"
            placeholder="선택하세요"
            value={selectedValue}
            onChange={(item) => setSelectedValue(item.value)}
            itemList={[
              { key: "opt1", value: "opt1", text: "옵션 1" },
              { key: "opt2", value: "opt2", text: "옵션 2" },
              { key: "opt3", value: "opt3", text: "옵션 3" },
            ]}
          />
        </Row>
        <Row>
          <DeleteButton />
          <DeleteButton disabled />
          <AddButton />
          <AddButton disabled />
          <RemoveButton />
          <RemoveButton disabled />
          <CloseIcon
            onClick={() => {
              alert("닫기 이벤트 적용");
            }}
          />
          <CloseIcon
            size={24}
            onClick={() => {
              alert("닫기 이벤트 적용");
            }}
          />
          <CloseIcon
            size={60}
            onClick={() => {
              alert("닫기 이벤트 적용");
            }}
          />
          <TimeInput
            label={"Time"}
            name={"time"}
            caption={"Test"}
            rules={{ required: true }}
          />
        </Row>

        <button type="submit" onClick={() => console.log(methods.getValues())}>
          제출
        </button>
      </FormProvider>
    </DefaultLayout>
  );
};
